import React from "react";
import * as S from "./styled";
import { Typography } from "../../Typography";

type TProps = React.InputHTMLAttributes<HTMLInputElement>;

const FitInput = React.forwardRef<HTMLInputElement, TProps>(({ value, placeholder, ...props }, ref) => {
    return (
        <Typography
            as="div"
            variant="label-small-regular"
            style={{ display: "flex", maxWidth: "100%", position: "relative", minWidth: "2px" }}
        >
            <S.StyledInput
                {...props}
                ref={ref}
                placeholder={placeholder}
                type="text"
                autoComplete="off"
                size={1}
                value={value}
            />
            <div style={{ visibility: "hidden", whiteSpace: "pre", flexShrink: 0 }}>{value || placeholder}</div>
        </Typography>
    );
});

export default FitInput;
